import axios from 'axios';
import {ModelFactory} from '@danhoss/model/factory'

export class AdditionalProductsClient {
    async getData() {
        const url = `/app/additional_products.php?action=get_additional_products`;
        const {data} = await axios.get(url);

        const factory = new ModelFactory();

        return factory.createModel('AdditionalProductsModel', data);
    }

}
